import React from "react";
import { loadModules } from "esri-loader";

import {
    arcgisJSUrl,
    arcgisCSSUrl,
    publicSTPFormUrl,
    publicSTPAssetNumber,
    publicSTPDescFuncLoc,
    arcgisGeocodeUrl,
    restArcgis
} from "../../utilities/constants";
import "./STPDataMapForm.css";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

class STPDataMapForm extends React.Component {
    constructor(props) {
        super(props);
        //this.checkToken();
        this.state = {
            tokenDetail: JSON.parse(localStorage.getItem("tokenDetail")),
            isChangeToken: false,
            queryResult: null,
            extentResult: null,
            apiUrl: arcgisJSUrl,
            apiCssUrl: arcgisCSSUrl,
            checkedSTPData: JSON.parse(localStorage.getItem("cartSTPData")) || [],
            pricePerSTP: null
        };
    }

    async componentDidMount() {
        while (!this.state.isChangeToken) {
            try {
                await this.getToken();
                this.setState({
                    isChangeToken: true
                });
            } finally {
            }
        }
        setInterval(() => {
            this.getToken();
        }, 50000);
        await this.getPricePerSTP();
        this.initializeMap();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.countSTPChange < this.props.countSTPChange) {
            var stpData = JSON.parse(localStorage.getItem("cartSTPData"));
            this.setState({
                checkedSTPData: stpData
            });
        }
    }

    /*letsWait = () => {
          return new Promise(resolve => {
              if (this.state.tokenDetail == null) {
                  console.log("There is no token detail");
                  setTimeout(() => { this.letsWait() }, 3000);
              }
              else {
                  resolve(1);
              }
          });
      };
  
      async checkToken() {
          var tokenDetail = localStorage.getItem("tokenDetail");
          if (tokenDetail != null) {
              tokenDetail = JSON.parse(tokenDetail);
          }
          if (tokenDetail == null || new Date() > tokenDetail.tokenExpired) {
              this.setState({
                  isChangeToken: true
              })
  
              let jj = async () => {
                  return new Promise(resolve => {
                      fetch('api/GetData/GetTokenArcgis')
                          .then(response => response.json())
                          .then(data => {
                              var dd = new Date();
                              dd.setHours(dd.getHours() + 1)
                              tokenDetail = { token: data.token, tokenExpired: dd };
                              localStorage.setItem("tokenDetail", JSON.stringify(tokenDetail));
                              resolve(1);
                          });
                  });
              };
              await jj();
              this.setState({
                  tokenDetail: JSON.parse(localStorage.getItem("tokenDetail"))
              });
  
          }
          setTimeout(() => { this.checkToken() }, 30000);
      }*/

    getToken = () => {
        return new Promise(async (resolve, reject) => {
            if (
                !this.state.tokenDetail ||
                new Date() > new Date(this.state.tokenDetail.tokenExpired)
            ) {
                try {
                    await this.fetchToken();
                } catch (err) {
                    reject(err);
                }
            }
            resolve(true);
        });
    };

    fetchToken = async () => {
        var response = await fetch("api/GetData/GetTokenArcgis");
        var data = await response.json();
        var dd = new Date();
        dd.setHours(dd.getHours() + 1);
        var tokenDetail = { token: data.token, tokenExpired: dd };
        this.setState({ tokenDetail });
        localStorage.setItem("tokenDetail", JSON.stringify(tokenDetail));
    };

    async selectData(item) {
        var checkedSTPData = this.state.checkedSTPData;
        var index = -1;
        checkedSTPData.map((stpData, i) => {
            if (stpData.assetNumber === item.assetNumber) {
                index = i;
            }
        });
        if (index !== -1) {
            checkedSTPData.splice(index, 1);
            item.checked = false;
        } else {
            item.checked = true;
            item.price = this.state.pricePerSTP;
            checkedSTPData.push(item);
        }
        this.setState({
            checkedSTPData
        });
    }

    isSelected(item) {
        var sameData = this.state.checkedSTPData.filter(
            stpData => stpData.assetNumber == item.assetNumber
        );
        if (sameData.length > 0) {
            return true;
        } else {
            return false;
        }
    }

    getPricePerSTP() {
        fetch("api/GetData/GetConfigValues?configName=STPDataPrice")
            .then(response => response.json())
            .then(data => {
                this.setState({ pricePerSTP: Number(data[0].value) });
            });
    }

    initializeMap() {
        loadModules(
            [
                "esri/views/MapView",
                "esri/Map",
                "esri/widgets/Search",
                "esri/identity/IdentityManager",
                "esri/layers/FeatureLayer",
                "esri/core/watchUtils",
                "esri/tasks/Locator",
                "esri/widgets/ScaleBar",
            ],
            { url: this.state.apiUrl, css: this.state.apiUrl + this.state.apiCssUrl }
        )
            .then(
                async ([
                    MapView,
                    Map,
                    Search,
                    IdentityManager,
                    FeatureLayer,
                    watchUtils,
                    Locator,
                    ScaleBar
                ]) => {
                    //await this.letsWait();

                    IdentityManager.registerToken({
                        server: restArcgis,
                        token: this.state.tokenDetail.token
                    });

                    /*this.setState({
                              isChangeToken: true
                          })
                          let checkTokenExpired = () => {
                              if (this.state.isChangeToken) {
                                  IdentityManager.registerToken({
                                      server: "https://igis.iwk.com.my/geoserver/rest/services",
                                      token: this.state.tokenDetail.token
                                  });
                                  this.setState({
                                      isChangeToken: false
                                  })
                              }
                          };
          
                          setInterval(() => { checkTokenExpired() }, 5000);
          
                          console.log({ ss: IdentityManager });*/

                    var publicSTPLayer = new FeatureLayer({
                        url: publicSTPFormUrl,
                        outFields: [publicSTPAssetNumber, publicSTPDescFuncLoc],
                        visible: false
                    });

                    const map = new Map({
                        basemap: "hybrid",
                        layers: [publicSTPLayer]
                    });

                    const view = new MapView({
                        container: "stpView",
                        map: map,
                        zoom: 7,
                        center: [102, 4]
                    });

                    const search = new Search({
                        view: view,
                        container: "stpSearch",
                        allPlaceholder: "STP Data or Address",
                        includeDefaultSources: false,
                        locationEnabled: false,
                        autoSelect: true,
                        goToOverride: (view, goToParams) => {
                            goToParams.target.zoom = 13;
                            return view.goTo(goToParams.target, goToParams.options);
                        },
                        sources: [
                            {
                                layer: publicSTPLayer,
                                searchFields: [publicSTPAssetNumber, publicSTPDescFuncLoc],
                                displayField: publicSTPAssetNumber,
                                exactMatch: false,
                                outFields: [publicSTPAssetNumber, publicSTPDescFuncLoc],
                                name: "Public STP",
                                placeholder: "Assets Number or Location",
                                zoomScale: 500000
                            },
                            {
                                locator: new Locator({ url: arcgisGeocodeUrl }),
                                singleLineFieldName: "SingleLine",
                                name: "Geocoding Service",
                                placeholder: "Find Address and Place",
                                maxResults: 3,
                                maxSuggestions: 6,
                                suggestionsEnabled: true,
                                minSuggestCharacters: 0
                            }
                        ]
                    });

                    search.on("search-complete", searchResult => {
                        if (searchResult.results[0].sourceIndex === 0) {
                            var attributes =
                                searchResult.results[0].results[0].feature.attributes;
                            this.setState({
                                queryResult: {
                                    assetNumber: attributes[publicSTPAssetNumber],
                                    locationName: attributes[publicSTPDescFuncLoc]
                                }
                            });
                        } else {
                            this.setState({
                                queryResult: null
                            });
                        }
                    });

                    search.on("search-start", () => {
                        this.setState({
                            queryResult: "Loading"
                        });
                    });

                    search.on("search-clear", () => {
                        this.setState({
                            queryResult: null
                        });
                    });

                    search.on("search-focus", () => {
                        const inputs = document.querySelectorAll(".esri-search__input");
                        for (var i = 0; i < inputs.length; i++) {
                            inputs[i].onfocusout = null;
                        }
                    });

                    watchUtils.whenTrue(view, "stationary", async () => {
                        if (view.extent) {
                            var queryParams = publicSTPLayer.createQuery();
                            queryParams.geometry = view.extent.extent;
                            queryParams.spatialRelationship = "intersects";
                            queryParams.num = 3;
                            queryParams.outFields = [
                                publicSTPAssetNumber,
                                publicSTPDescFuncLoc
                            ];
                            if (
                                typeof this.state.queryResult === "object" &&
                                this.state.queryResult
                            ) {
                                queryParams.where =
                                    "NOT " +
                                    publicSTPAssetNumber +
                                    " = '" +
                                    this.state.queryResult.assetNumber +
                                    "'";
                            }

                            this.setState({
                                extentResult: null
                            });
                            var queryResult = await publicSTPLayer.queryFeatures(queryParams);
                            var extentResult = [];
                            await queryResult.features.map(feature => {
                                extentResult.push({
                                    assetNumber: feature.attributes[publicSTPAssetNumber],
                                    locationName: feature.attributes[publicSTPDescFuncLoc]
                                });
                            });
                            this.setState({
                                extentResult
                            });
                        }
                    });

                    view.ui.add(search, {
                        position: "top-left"
                    });
                    /*view.ui.remove('zoom');*/

                    var scaleBar = new ScaleBar({
                        view: view,
                        unit: "dual"
                    });

                    view.ui.add(scaleBar, {
                        position: "bottom-left"
                    });
                }
            )
            .catch(err => {
                console.error("Failed to initialize map: " + err);
            });
    }

    render() {
        return (
            <div className="background-color">
                <div>
                    <div id="stpView" className="mapViews" />
                    <div id="stpSearch" />
                    <div className="row">
                        <div className="col-sm">
                            <h6>By Query</h6>
                            {this.state.queryResult && this.state.queryResult !== "Loading" && (
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={this.state.queryResult.assetNumber}
                                        value={this.state.queryResult.assetNumber}
                                        onChange={() => this.selectData(this.state.queryResult)}
                                        checked={this.isSelected(this.state.queryResult)}
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor={this.state.queryResult.assetNumber}
                                    >
                                        {this.state.queryResult.assetNumber}
                                    </label>
                                    <br />
                                    <label
                                        className="form-check-label"
                                        htmlFor={this.state.queryResult.assetNumber}
                                    >
                                        {this.state.queryResult.locationName}
                                    </label>
                                </div>
                            )}
                            {!this.state.queryResult && (
                                <p>
                                    To get data, search using asset number or location name on map
                                    search box
                </p>
                            )}
                            {this.state.queryResult === "Loading" && <LoadingSpinner />}
                        </div>
                        <div className="col-sm">
                            <h6>By Extent</h6>
                            {!this.state.extentResult && <LoadingSpinner />}
                            {this.state.extentResult &&
                                this.state.extentResult.map(extentResult => (
                                    <div className="form-check" key={extentResult.assetNumber}>
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id={extentResult.assetNumber}
                                            value={extentResult.assetNumber}
                                            onChange={() => this.selectData(extentResult)}
                                            checked={this.isSelected(extentResult)}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor={extentResult.assetNumber}
                                        >
                                            {extentResult.assetNumber}
                                        </label>
                                        <br />
                                        <label
                                            className="form-check-label"
                                            htmlFor={extentResult.assetNumber}
                                        >
                                            {extentResult.locationName}
                                        </label>
                                    </div>
                                ))}
                        </div>
                    </div>
                    <div>
                        <button
                            type="button"
                            className="btn btn-primary width100"
                            onClick={() =>
                                this.props.addToCartSTPData(this.state.checkedSTPData)
                            }
                        >
                            Add to cart
            </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default STPDataMapForm;



// WEBPACK FOOTER //
// ./src/components/STPData/STPDataMapForm.js